export default __webpack_public_path__ + "3a96ad69506584975f0a6fed85bc059f.svg";